module.exports = __webpack_public_path__ + "img/odonto_emergenza_singolo.86908e38.jpg";